import { TemplateCard } from './TemplateCard';
import type { TemplateCardData } from './TemplateCard';

interface TemplateCardsProps {
  templates: TemplateCardData[];
}

/**
 * Renders 1-5 template cards in a vertical stack inside the OptiBot chat bubble.
 */
export function TemplateCards({ templates }: TemplateCardsProps) {
  if (templates.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-2">
      {templates.map((template) => (
        <TemplateCard key={template.templateId} {...template} />
      ))}
    </div>
  );
}
